/*
 * Die Rückfrage des Belegdesigners vor „Ablage übernehmen“ (Entscheid 687, Hausregel „Bestätigung vor
 * Datenänderung“). Die Folge steht so in api/src/routes/layouts.ts (R9: „Das Dokument der Engine wird Entwurf UND
 * Freigabestand“); den Satz zu ungespeicherten Eingaben und die Gefahr-Gestalt nur dann, wie bei „Layout neu laden“
 * (Rot-Regel: Kopf von `useBestaetigung` in @kundeninfo/ui).
 * Schlüssel englisch, Werte deutsch (Hausregel „Texte in Properties“).
 */
export const LAYOUT_TEXT = {
  adoptStoreTitle: "Ablage übernehmen?",
  adoptStoreText: (ungespeichert: boolean): string =>
    "Der Stand aus der Render-Engine wird Entwurf und Freigabestand dieses Layouts."
    + (ungespeichert ? " Ungespeicherte Eingaben gehen dabei verloren." : ""),
  adoptStore: "Übernehmen",
};
